import { render } from "./percentile.html?vue&type=template&id=6cefeb8e&scoped=true&ts=true&external"
import script from "./percentile.ts?vue&type=script&lang=ts&external"
export * from "./percentile.ts?vue&type=script&lang=ts&external"

import "./percentile.scss?vue&type=style&index=0&id=6cefeb8e&scoped=true&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cefeb8e"]])

export default __exports__